import React from 'react';
import Modal from 'react-bootstrap/Modal'
import Button from 'react-bootstrap/Button'
import { MDBContainer, MDBTable, MDBTableBody, MDBTableHead, MDBDataTable } from 'mdbreact';
import * as misConstantes from '../../../../../js/constantes.js';
import InicioBreadcrumbs from '../../../../../pages/template/breadcrumbs/InicioBreadcrumbs.js'

import {
	Switch,
	Route,
	BrowserRouter,
	Link,
	useLocation,
	useParams
} from "react-router-dom";

import axios from "axios";



class SimulacionProveedors extends React.Component {
	constructor(props) {
	    super(props);
		
		var url = window.location.href;
		var data = url.split("/");
		
		var idCotizacion = data[data.length - 2];
		var idSimulacionProveedor = data[data.length - 1];
		
		
 		var columnas = [ 
								{ field: "poducto", label: "Producto", attributes: {'width':'40%'} },
								
								{ field: "sprecioUnitarioCatalogo", label: "Unit. catálogo", attributes: {'width':'15%'} },
								{ field: "sprecioUnitarioFormula", label: "Unit. fórmula", attributes: {'width':'15%'} },
								
								{ field: "cantidad", label: "Cantidad", attributes: {'width':'10%'} },
								{ field: "subtotal", label: "Subtotal", attributes: {'width':'15%'} },
								
								{ field: "botones", label: "", attributes: {'width':'5%'} }
 
 						];
					
					
		var columnasDetalle = [ 
								{ field: "variables", label: "Variable", attributes: {'width':'65%'} },
								{ field: "valor", label: "Valor", attributes: {'width':'35%'} }
 
 						];
		
		
	    this.state = {  
	    						datos: {columns: columnas, rows:[]}, 
								mostrarInsertarItemSimulacionProveedor: false, estaInsertarItemSimulacionProveedor:"",precioInsertarItemSimulacionProveedor:"", respuestaInsertarItemSimulacionProveedor: "", 
								mostrarEditarItemSimulacionProveedor: false, estaEditarItemSimulacionProveedor:"",precioEditarItemSimulacionProveedor:"", idEditarSimulador: -1, respuestaEditarItemSimulacionProveedor: "", 
								mostrarEliminarItemSimulacionProveedor: false, nombreEliminarItemSimulacionProveedor:"", idEliminarItemSimulacionProveedor: -1, respuestaEliminarItemSimulacionProveedor: "",
								columnas: columnas, 
								idCotizacion:idCotizacion,
								idSimulacionProveedor:idSimulacionProveedor,
								nombreSimulacion: "", linkSimulacion: "", nombreProveedor: "", valor:"", 
								datosExtras: [], tipoSimulacion: 1, mostrarCantidad: "none", cantidad: "", simulacionProveedor:"", ivaDefecto: "", valorIVA:"", valorAntesIVA: "",
								
								datos: {columns: columnasDetalle, rows:[]}, mostrarDetalleCalculo: false, datosDetalleItem: <></>
						};
	}
	componentDidMount() {
		this.cargarItemSimulacionProveedors();
		
		var codigo = localStorage.getItem('simuladores.proveedores.codigoUsuario' );
		var idCotizacion = this.state.idCotizacion;
		var idSimulacionProveedor = this.state.idSimulacionProveedor;
		var infoSimulacion = {"codigo":codigo, "idCotizacion":idCotizacion} 
		axios.post( misConstantes.URL_CONSULTA + '/ServletSimulacion', infoSimulacion, {params: infoSimulacion}).then(function (response) {
			var simulacion = response.data;
			
			var tipoSimulacion = simulacion.simulador.tipo;
			
			var mostrarCantidad = "none";
			if( tipoSimulacion == 2 ){
				mostrarCantidad = "";
			}
			
			var nombreSimulacion = simulacion.simulador.nombre + " - " + simulacion.fechaCreacion;
			var linkSimulacion = "/cotizacion/" + this.state.idCotizacion;
			this.setState( {nombreSimulacion: nombreSimulacion, linkSimulacion:linkSimulacion, tipoSimulacion: tipoSimulacion, mostrarCantidad: mostrarCantidad} );
			
			
			var datosExtras = [];
			var datos = simulacion.jdatos;
//			alert(datos);
//			alert( JSON.stringify( datos )   );

			for( var i = 0; i < datos.length; i++ ){
				var caracteristica = datos[i].caracteristica;
				var valor = datos[i].valor;
				
				var datoExtra = <><tr><td>{ caracteristica.nombre }</td><td>{ valor }</td></tr></>;
				datosExtras.push(datoExtra);
			}
			

			
			this.setState( {datosExtras:datosExtras}  );
			
		}.bind(this)).catch(function (error) {
		});
		
		var info = {"codigo":codigo,"idCotizacion":idCotizacion,"id":idSimulacionProveedor} 
		axios.post( misConstantes.URL_CONSULTA + '/ServletSimulacionProveedor', info, {params: info}).then(function (response) {
			var simulacionProveedor = response.data;
//			alert( JSON.stringify( simulacionProveedor ) );
			
			var proveedor = simulacionProveedor.proveedor;
			var nombreProveedor = proveedor.nombre;
			var valor = simulacionProveedor.svalor;
			var cantidad = simulacionProveedor.scantidad;
			var presupuesto = simulacionProveedor.spresupuesto;
			var ivaDefecto = simulacionProveedor.sivaDefecto;
			var valorIVA = simulacionProveedor.svalorIVA;
			var valorAntesIVA = simulacionProveedor.svalorAntesIVA;
			var svalorTotal = simulacionProveedor.svalorTotal;
			var svalorIVADefinitivo = simulacionProveedor.svalorIVADefinitivo;
			var svalor = simulacionProveedor.svalor;
//			svalor
//			ivaDefecto: "", valorIVA:"", valorAntesIVA: ""
			
			if(simulacionProveedor.valida == 2){
				valor = "";
			}
			this.setState({nombreProveedor:nombreProveedor, valor:valor, cantidad: cantidad, presupuesto: presupuesto, ivaDefecto:ivaDefecto, valorIVA:valorIVA, valorAntesIVA: valorAntesIVA, svalorTotal: svalorTotal, svalorIVADefinitivo:svalorIVADefinitivo, svalor:svalor });
			
		}.bind(this)).catch(function (error) {
		});
	}
	

	
	
	render(){
		 
	
		 return (
			<>
				<div class="menu" style={{backgroundColor:  "#dbe7fc", width: "100%", padding: "10px", fontSize: "12px" }}>
					<div class="container">
						<InicioBreadcrumbs></InicioBreadcrumbs> / <Link to = '/cotizaciones'>Cotizaciones</Link> / Cotizacion: <Link to = { this.state.linkSimulacion}> {this.state.nombreSimulacion} </Link> / { this.state.nombreProveedor }
					</div>
				</div>
				
				
				<div class="container" style={{minHeight: '550px', paddingTop: "30px"}}>
					<div class = 'subitulosPaginaNotificaciones'>
						<b>Simulación: {this.state.nombreSimulacion}: { this.state.nombreProveedor }</b>
					</div><br/>
				
					<div class="row">
						<div class="col-xl-3 col-lg-3 col-md-4 col-sm-12 col-xs-12"  style = {{ display:  this.state.mostrarBotonesAbiertos }} >
							<Button variant="primary" style = {{ width: "100%"} }  onClick={ this.handleIrACotizacion.bind(this) }>
					        	<i class="fas fa-chevron-circle-left"></i> Volver a cotización
					      	</Button>
						</div>
						
					</div>
					<br/>
					<div class="fila">
						
					
						<div class="col-lg-6 col-md-6 col-sm-12 mr-auto" style={{paddingLeft: "10px !important"}} >
							
							<table class = 'table table-bordered table-hover table-sm table-striped dataTable'>
								<tbody data-test="table-body">
									<tr>
										<td width = '35%'>Proveedor</td>
										<td width = '65%'>{ this.state.nombreProveedor }</td>
									</tr>
									<tr>
										<td>Simulacion</td>
										<td>{this.state.nombreSimulacion}</td>
									</tr>
									<tr style = { { display: this.state.mostrarCantidad} } >
										<td>Cantidad</td>
										<td>{ this.state.cantidad }</td>
										
									</tr>
									<tr style = { { display: this.state.mostrarCantidad} } >
										<td>Presupuesto</td>
										<td>{ this.state.presupuesto }</td>
										
									</tr>
									
									
									{/** <tr style = { { display: this.state.mostrarCantidad} } >
										<td>IVA Defecto</td>
										<td>{ this.state.ivaDefecto }</td>
										
									</tr>
									<tr style = { { display: this.state.mostrarCantidad} } >
										<td>Valor IVA</td>
										<td>{ this.state.valorIVA }</td>
									</tr>
									<tr style = { { display: this.state.mostrarCantidad} } >
										<td>Valor antes IVA</td>
										<td>{ this.state.valorAntesIVA }</td>
									</tr>
									
									
									<tr>
										<td>Valor total	</td>
										<td>{this.state.valor}</td>
									</tr> */}
									{ this.state.datosExtras }
								</tbody>
							</table>
						</div>

					</div>
					
					<br/>
					
					<div style = {{ whiteSpace: "pre-wrap" }}>
						<MDBDataTable striped bordered  small data={ this.state.datos } hover entriesOptions={[5, 10, 15, 25]} entries={15} pagesAmount={4} condensed/>
					</div>
					<br/><br/>
					<div class="fila">
						
						<div class="col-lg-6 col-md-6 col-sm-12 mr-auto">
						</div>
						<div class="col-lg-6 col-md-6 col-sm-12 mr-auto" style={{paddingLeft: "10px !important"}} >
							
							<table class = 'table table-bordered table-hover table-sm table-striped dataTable'>
								<tbody data-test="table-body">
									<tr>
										<td width = '35%'>Subtotal:</td>
										<td width = '65%'>{ this.state.svalor }</td>
									</tr>
								
									<tr>
										<td width = '35%'>Total IVA:</td>
										<td width = '65%'>{ this.state.svalorIVADefinitivo }</td>
									</tr>
									
									<tr>
										<td width = '35%'>Total:</td>
										<td width = '65%'>{ this.state.svalorTotal }</td>
									</tr>
									
								</tbody>
							</table>
						</div>

					</div>
					<br/><br/>
				
				
				{ /**
				// ------------------------------------------------------------------------------------------------------
				// ItemSimulacionProveedor
				// ------------------------------------------------------------------------------------------------------
				 */}
				
					 
				
				
					<Modal show={ this.state.mostrarDetalleCalculo } onHide={  this.handleCloseDetalleCalculo.bind(this)  }>
						 <Modal.Header closeButton>
							 <Modal.Title>Detalle calculo</Modal.Title>
						 </Modal.Header>
						 <Modal.Body>
							<table class = 'table table-bordered table-hover table-sm table-striped dataTable'>
								<tbody data-test="table-body">
									
									{ this.state.datosDetalleItem }
								</tbody>
							</table>
							</Modal.Body>
						 <Modal.Footer>
							<Button variant="secondary" onClick = { this.handleCloseDetalleCalculo.bind( this ) }>Cerrar</Button>
						 </Modal.Footer>
					 </Modal>
				
				</div>
			
			</>
			
		)
	}
	
	

	// ------------------------------------------------------------------------------------------------------
	// ItemSimulacionProveedor
	// ------------------------------------------------------------------------------------------------------
	handleIrACotizacion(event){
		window.location.href = "/cotizacion/" + this.state.idCotizacion;
	}
	handleCloseInsertarItemSimulacionProveedor(event){
		this.setState({ mostrarInsertarItemSimulacionProveedor: false });
	}
	
	handleCloseEditarItemSimulacionProveedor(event){
		this.setState({ mostrarEditarItemSimulacionProveedor: false });
	}
	handleCloseEliminarItemSimulacionProveedor(event){
		this.setState({ mostrarEliminarItemSimulacionProveedor: false });
	}
	handleCloseDetalleCalculo(event){
		this.setState({ mostrarDetalleCalculo: false });
	}
	// ----------------------------------------
	// Detalle
	// ----------------------------------------
	
	abrirDialogoDetalleCalculo(event, id){
//		alert( id );
		
		event.preventDefault();
		this.setState({ mostrarDetalleCalculo: true });
		
		var codigo = localStorage.getItem('simuladores.proveedores.codigoUsuario' );
		var idCotizacion = this.state.idCotizacion;
		var idSimulacionProveedor = this.state.idSimulacionProveedor;
		var idItemSimulacionProveedor = id;
		var info = { "codigo":codigo, "idCotizacion":idCotizacion,"idSimulacionProveedor":idSimulacionProveedor,"idItemSimulacionProveedor":idItemSimulacionProveedor };
		
		
		axios.post( misConstantes.URL_CONSULTA + '/ServletDatosItemSimulacionCalculo', info, {params: info}).then(function (response) {
//			alert( JSON.stringify(response.data) );
//			var datosDetalleItem = 
			var data = response.data;
			var dataFor = data.datos;
			var datosFormulaTabla = [];
			for(  var i = 0; i < dataFor.length;i++ ){
//				if( dataFor[i].codigo != "valorCatalogo" ){
					var fila = <><tr><td>{ dataFor[i].codigo }</td><td>{ dataFor[i].valor }</td></tr></>;
					datosFormulaTabla.push(fila);
//				}
				
				
			}
			
			var datosDetalleItem = <>
									<tr>
										<td colspan = "2">{ data.nombreFormula }</td>
									</tr>
									<tr>
										<td width = '55%'>Formula</td>
										<td width = '45%'>{ data.formula }</td>
									</tr>
									{ datosFormulaTabla }
									<tr>
										<td colspan = "2"><b>Totales</b></td>
									</tr>
									<tr>
										<td>Valor unitario catálogo</td>
										<td>{ data.sprecioUnitarioCatalogo }</td>
									</tr>
									<tr>
										<td>Total unitario fórmula</td>
										<td>{ data.sprecioUnitarioCatalogoFormula }</td>
									</tr>
									<tr>
										<td><b>Total</b></td>
										<td>{ data.stotal }</td>
									</tr>
								</>;
			
			
			this.setState( {datosDetalleItem: datosDetalleItem} );
			
		}.bind(this)).catch(function (error) {
		});
	}
	
	// ----------------------------------------
	// Cargar ItemSimulacionProveedor
	// ----------------------------------------
	cargarItemSimulacionProveedors(){
		var codigo = localStorage.getItem('simuladores.proveedores.codigoUsuario' );
		var idCotizacion = this.state.idCotizacion;
		var idSimulacionProveedor = this.state.idSimulacionProveedor;
		
		var info = { "codigo": codigo, "idCotizacion":idCotizacion,"idSimulacionProveedor":idSimulacionProveedor};
		axios.post( misConstantes.URL_CONSULTA + '/ServletItemSimulacionProveedorsJSON', info, {params: info}).then(function (response) {
			var datosFinales = response.data;
			
//			alert( JSON.stringify( datosFinales ) );
			
			var columns = this.state.columnas;
			var rows = [];
			for( var i = 0; i < datosFinales.length; i++ ){

				var scantidad = datosFinales[i].scantidad;
				var ssubtotal = datosFinales[i].stotal;
				var sprecioUnitario = datosFinales[i].sprecioUnitario;
				if( sprecioUnitario + "" == "-1" ){
					sprecioUnitario = "";
					scantidad = "";
					ssubtotal = "";
				}
				
				
				
				var data = datosFinales[i].itemSimulacion.data;
				var textoExtras = [];
				for( var j = 0; j < data.length - 1;j++){
					var valor = data[j].label;
					if( valor == null ){
						var textoExtra = <><span style = 'font-style: italic; font-size: 10px;'>{ data[j].value }</span></>;
						textoExtras.push(textoExtra);
					}
					if( valor != null ){
						var textoExtra = <><span style = 'font-style: italic; font-size: 10px;'> - { valor }</span></>;
						textoExtras.push(textoExtra);
					}
					
				}
				
				
				const identificador = datosFinales[i].id + "";
				
				var botones = <></>
				if(  datosFinales[i].itemSimulacion.tipo == 1  ){
					botones = <>
								<div style = {{width: "100%", textAlign: "center" }}>
									<a href = ''  onClick = {  (event) => this.abrirDialogoDetalleCalculo(event, identificador ) }  >
										<i class="fas fa-info-circle"></i>
									</a>
								</div>
							</>;
				}
				var sproducto = <>{ datosFinales[i].itemSimulacion.referencia }. { datosFinales[i].itemSimulacion.texto }<br/></>;
				var sprods = [];
				sprods.push(sproducto);
//				sprods.push(textoExtras);
				
				var row = {
							poducto: sprods,
							sprecioUnitarioCatalogo: datosFinales[i].sprecioUnitarioCatalogo,
							sprecioUnitarioFormula: <>{ datosFinales[i].sprecioUnitarioCatalogoFormula }<br/>IVA: { datosFinales[i].svalorIVA }</>,
							cantidad: scantidad,
							subtotal: ssubtotal,
							botones: botones
						}
//				alert( JSON.stringify(datosFinales[i]) );

				if(  datosFinales[i].itemSimulacion.tipo == 1  ){
					if( datosFinales[i].producto.mostrarSimulacion + "" == "true" ){
						rows.push(row);
					}
				}		
				
				if(  datosFinales[i].itemSimulacion.tipo == 2  ){
					rows.push(row);
				}

//				if( datosFinales[i].producto.mostrarSimulacion + "" == "true" ){
//					rows.push(row);
//				}
				
			}

			var datos = {columns: columns, rows: rows}
			this.setState({datos: datos});
			
		}.bind(this)).catch(function (error) {
		});
	}
	
	// ----------------------------------------
	// Insertar ItemSimulacionProveedor
	// ----------------------------------------
	handleShowInsertarItemSimulacionProveedor(event){
		event.preventDefault();
		this.setState({ mostrarInsertarItemSimulacionProveedor: true });
	}
	insertarEstaInsertarItemSimulacionProveedor(event){
		var estaInsertarItemSimulacionProveedor = event.target.value;
		this.setState( {estaInsertarItemSimulacionProveedor: estaInsertarItemSimulacionProveedor} );
	}
	insertarPrecioInsertarItemSimulacionProveedor(event){
		var precioInsertarItemSimulacionProveedor = event.target.value;
		this.setState( {precioInsertarItemSimulacionProveedor: precioInsertarItemSimulacionProveedor} );
	}

	formularioInsertarItemSimulacionProveedor( event ){
		event.preventDefault();
		this.insertarItemSimulacionProveedor( event );
	}
	
	
	// ----------------------------------------
	// Eliminar ItemSimulacionProveedor
	// ----------------------------------------
//	handleDescargarExcel(){
//		var idSimulacion = this.state.idSimulacion;
//		var idSimulacionProveedor = this.state.idSimulacionProveedor;
////		this.setState( {idSimulacion:idSimulacion, idSimulacionProveedor:idSimulacionProveedor } );
//		
//		var url = misConstantes.URL_CONSULTA + "/comparadorSimulaciones.xlsx?idSimulacion=" + idSimulacion + "&idSimulacionProveedor=" + idSimulacionProveedor;
////		alert(url);
//		
//		window.open( url, "_blank" );
//	}
}

export default SimulacionProveedors;
